<template>
  <div>
    <PageLoader v-bind:storage="appLoading" v-bind:contain="true" />
    <ServerError v-if="ServerError" />

    <v-layout wrap justify-start px-0 px-sm-4 pt-4>
      <v-flex xs12 sm3 md3 lg3 xl3 text-left text-uppercase>
        <span
          style="
            font-family: poppinssemibold;
            font-size: 16px;
            color: #000000;
            letter-spacing: 1px;
          "
        >
          Orders
        </span>
      </v-flex>
      <!-- <v-flex xs12 pt-4>
        <v-divider></v-divider>
      </v-flex> -->
      <v-flex xs12 pt-4>
        <v-layout wrap justify-start v-if="products.length > 0">
          <v-flex xl12 pa-2 v-for="(item, i) in products" :key="i" text-left>
            <v-layout wrap justify-center>
              <v-flex xs12>
                <OrderItem v-bind:storage="item" @stepper="winStepper" />
              </v-flex>
              <v-flex xs12 py-4>
                <v-divider></v-divider>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-layout wrap justify-center v-else>
          <v-flex xs12 pa-2 align-self-center>
            <span
              style="
                font-family: poppinsregular;
                font-size: 25px;
                color: #000000;
                cursor: pointer;
              "
              >Oops! No Products Found</span
            >
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
import OrderItem from "./orderItem";
export default {
  components: {
    OrderItem,
  },
  data() {
    return {
      appLoading: false,
      showSnackBar: false,
      timeout: 5000,
      msg: null,
      products: [],
      ServerError: false,
      searchKey: null,
    };
  },
  beforeMount() {
    this.getData();
  },
  methods: {
    getData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/purchase/myorders",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.products = response.data.data;
          } else {
            this.products = [];
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    winStepper(item) {
      if (item.getData) {
        this.getData();
      }
      this.msg = item.response.msg;
      this.showSnackBar = true;
    },
    appSearch() {},
  },
};
</script>
